<template>
    <div class="wrapper">
        <div class="control">
            <DatePicker :set-max="max" class="datePicker combo-item" @close="datePickerClosed"></DatePicker>
            <InfoBubble class="dateBubble combo-item" @bubbleDeleted="removeRange" v-if="rangeString!==''" color="blue"
                        :isFilled=true :deletable="false" :disabled="disabled"
                        :value="rangeString"
            ></InfoBubble>
        </div>
        <div class="control">
            <Checkbox v-if="addRadioOptions" class="radio combo-item"
                      @change="updateRadios('yesterday_cbx', ...arguments)"
                      :key="'radio-yesterday-'+id"
                      :id="'radio-yesterday-'+id"
                      title="Gestern" v-model="yesterday_cbx" :rounded="true"
            ></Checkbox>
            <Checkbox class="radio combo-item" @change="updateRadios('seven_cbx', ...arguments)"
                      :key="'radio-7-'+id"
                      :id="'radio-7-'+id"
                      title="7 Tage" v-model="seven_cbx" :rounded="true"
            ></Checkbox>
            <Checkbox class="radio combo-item" @change="updateRadios('fourteen_cbx', ...arguments)"
                      :key="'radio-14-'+id"
                      :id="'radio-14-'+id"
                      title="14 Tage" v-model="fourteen_cbx" :rounded="true"
            ></Checkbox>
        </div>
    </div>
</template>

<script>
import DatePicker from "./DatePicker";
import InfoBubble from "../inputs/InfoBubble";
import Checkbox from "../inputs/Checkbox";
import moment from 'moment';

export default {
    name: "DateSelectionCombo",
    components: {Checkbox, InfoBubble, DatePicker},
    props: {
        addRadioOptions: {
            type: Boolean,
            default: false
        },
        isSeven: {
            type: Boolean,
            default: false
        },
        isFourteen: {
            type: Boolean,
            default: false
        },
        isYesterday: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            required: true
        },
        initialRange: {
            type: Object,
            required: false
        },
        global: {
            type: Boolean,
            default: true
        },
        max: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {    // wenn nicht advertiser dann dmt_accumulated_dmt
        //wenn advertiser dann nicht dmt_accumulated_dmt
        return {
            range: {
                start: {},
                end: {}
            },
            yesterday_cbx: false,
            seven_cbx: false,
            fourteen_cbx: false
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        rangeString() {
            if ((this.range.start && Object.keys(this.range.start).length === 0 && this.range.start.constructor === Object) && (this.range.end && Object.keys(this.range.end).length === 0 && this.range.end.constructor === Object)) {
                return '';
            }
            return moment(this.range.start, 'YYYY-MM-DD').format('DD.MM.YY') + ' - ' + moment(this.range.end, 'YYYY-MM-DD').format('DD.MM.YY');
        },
        selectedDates() {
            if (this.yesterday_cbx) {
                return {
                    start: moment().subtract(1, 'd').format('YYYY-MM-DD'),
                    end: moment().subtract(1, 'd').format('YYYY-MM-DD')
                };
            }
            if (this.seven_cbx) {
                return {
                    start: moment().subtract(7, 'd').format('YYYY-MM-DD'),
                    end: moment().subtract(1, 'd').format('YYYY-MM-DD')
                };
            }
            if (this.fourteen_cbx) {
                return {
                    start: moment().subtract(14, 'd').format('YYYY-MM-DD'),
                    end: moment().subtract(1, 'd').format('YYYY-MM-DD')
                };
            }
            if (this.rangeString !== '') {
                return {
                    start: moment(this.range.start).format('YYYY-MM-DD'),
                    end: moment(this.range.end).format('YYYY-MM-DD')
                };
            }
            return {};
        },
        dates() {
            let dates = [];
            if (Object.keys(this.selectedDates).length !== 0 && this.selectedDates.constructor === Object) {
                let currentDate = moment(this.selectedDates.start);
                let stopDate = moment(this.selectedDates.end);
                while (currentDate.isSameOrBefore(stopDate)) {
                    dates.push(currentDate.format('YYYY-MM-DD'));
                    currentDate = currentDate.add(1, 'd');
                }
            }
            return dates;
        }
    },
    methods: {
        init() {
            let dateRange = null;
            if (this.$route.name === 'deals') {
                dateRange = sessionStorage.getItem('rangeAll');
            } else if (this.$route.name === 'mydeals' || (sessionStorage.getItem('latestPresetId') !== "null" && sessionStorage.getItem('latestPresetId') !== "undefined")) {
                dateRange = sessionStorage.getItem('rangePreset');
            } else if (this.$route.name === 'mydealsall') {
                dateRange = sessionStorage.getItem('rangeMy');
            }

            if (this.global && dateRange) {
                dateRange = JSON.parse(dateRange)
                if (typeof dateRange.end !== 'undefined' && typeof dateRange.start !== 'undefined') {
                    if (moment().subtract(1, 'days').isSame(moment(dateRange.end), 'day') && moment().subtract(7, 'days').isSame(moment(dateRange.start), 'day')) {
                        this.seven_cbx = true;
                    } else if (moment().subtract(1, 'days').isSame(moment(dateRange.end), 'day') && moment().subtract(14, 'days').isSame(moment(dateRange.start), 'day')) {
                        this.fourteen_cbx = true;
                    } else {
                        this.range = dateRange;
                    }
                }
                this.emitChange();
            } else if (this.isYesterday) {
                this.yesterday_cbx = this.isYesterday;
                this.emitChange();
            } else if (this.isSeven) {
                this.seven_cbx = this.isSeven;
                this.emitChange();
            } else if (this.isFourteen) {
                this.fourteen_cbx = this.isFourteen;
                this.emitChange();
            } else if (this.initialRange && typeof this.initialRange.start !== 'undefined' && typeof this.initialRange.end !== 'undefined') {
                if (moment().subtract(1, 'days').isSame(moment(this.initialRange.end), 'day') && moment().subtract(7, 'days').isSame(moment(this.initialRange.start), 'day')) {
                    this.seven_cbx = true;
                } else if (moment().subtract(1, 'days').isSame(moment(this.initialRange.end), 'day') && moment().subtract(14, 'days').isSame(moment(this.initialRange.start), 'day')) {
                    this.fourteen_cbx = true;
                } else if (moment().subtract(1, 'days').isSame(moment(this.initialRange.end), 'day') && moment().subtract(1, 'days').isSame(moment(this.initialRange.start), 'day')) {
                    this.yesterday_cbx = true;
                } else {
                    this.range = this.initialRange;
                }
                this.emitChange();
            }
        },
        datePickerClosed: function (range) {
            this.range = range;
            this.seven_cbx = false;
            this.fourteen_cbx = false;
            this.yesterday_cbx = false;
            this.emitChange();
        },
        updateRadios(radio) {
            //this.seven_cbx = radio === '7 days' ? checked : false;
            //this.fourteen_cbx = radio === '14 days' ? (checked || this.fourteen_cbx) : false;
            //this.yesterday_cbx = radio === 'yesterday' ? (checked || this.yesterday_cbx) : false;
            this.seven_cbx = false;
            this.fourteen_cbx = false;
            this.yesterday_cbx = false;
            this[radio] = true;

            this.removeRange();
        },
        removeRange() {
            this.range = {
                start: {},
                end: {}
            };
            this.emitChange();
        },
        async emitChange() {
            if (this.global) {
                if (!(this.selectedDates.start === this.$store.state.deals.range.start && this.selectedDates.end === this.$store.state.deals.range.end)) {
                    await this.updateStore();
                    this.saveToStorage();
                    this.$root.$emit('dateChange', this.selectedDates);
                }
            } else {
                this.$emit('dateChange', this.selectedDates);
            }
        },
        async updateStore() {
            this.$store.commit('deals/setRange', this.selectedDates);
            if (this.dates.length === 0) {
                await this.$store.dispatch('deals/fetchAllAvailableDates', this.dates);
            } else {
                this.$store.commit('deals/setDates', this.dates);
            }
        },
        saveToStorage() {
            if (this.$route.name === 'deals') {
                sessionStorage.setItem('rangeAll', JSON.stringify(this.selectedDates));
            } else if (this.$route.name === 'mydealsall') {
                sessionStorage.setItem('rangeMy', JSON.stringify(this.selectedDates));
            } else if (this.$route.name === 'mydeals') {
                sessionStorage.setItem('rangePreset', JSON.stringify(this.selectedDates));
            }
        },
    },
    watch: {
        initialRange(oldVal, newVal) {
            if (oldVal && JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
                console.log('watcher init')
                this.init();
            }
        }
    },
}
</script>

<style lang="scss" scoped>

.radio.checkbox-container {
    margin-left: .5rem;
    margin-right: .5rem;
}

.dateBubble {
    margin-left: 2rem;
    display: inline-block;
}

.datePicker {
    display: inline-block;
}

.control {
    display: inline-block;
    margin-right: 1rem;
}

@media (max-width: 767px) {
    .combo-item {
        margin-bottom: 1rem;
    }

    .wrapper {
        margin-top: 1rem;
        margin-bottom: -1rem;
    }

}

/*
@media (min-width: 1025px) {
    .control{
        margin-bottom: 1rem;
    }
    .filtersInner{
        margin-bottom: -1rem;
    }

}*/
</style>